import { useEffect } from 'react';
import type { PublisherConfig } from '../../../types/selfService';
import { usePublisherConfig } from '../../../data/publisherConfigs';

export function stationAccentColors(config: PublisherConfig | null | undefined): {
  accent: string | undefined;
  primary: string | undefined;
} {
  return {
    accent: config?.accentColor || config?.primaryColor,
    primary: config?.primaryColor,
  };
}

export function usePublisherFont(config: PublisherConfig | null | undefined): void {
  useEffect(() => {
    if (!config?.fontUrl) return;
    const existingLink = document.querySelector(`link[href="${config.fontUrl}"]`);
    if (existingLink) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = config.fontUrl;
    document.head.appendChild(link);
    return () => {
      link.remove();
    };
  }, [config?.fontUrl]);
}

export function useStationHelpBranding(slug: string | undefined) {
  const { config, loading } = usePublisherConfig(slug);
  usePublisherFont(config);
  const { accent, primary } = stationAccentColors(config);
  return { config, loading, accent, primary };
}
